const i18nTopicList = [
  {
    relatedTopic: {
      topicString: {
        en: 'Data Analysis',
        es: 'Análisis de datos',
      },
      topicUrl: 'learn/data-analysis',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Excel',
        es: 'Excel',
      },
      topicUrl: 'learn/excel',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Machine Learning',
        es: 'Aprendizaje automático',
      },
      topicUrl: 'learn/machine-learning',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'R Programming',
        es: 'Programación en R',
      },
      topicUrl: 'learn/r-programming',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'SQL',
        es: 'SQL',
      },
      topicUrl: 'learn/sql',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'App Development',
        es: 'Desarrollo de aplicaciones',
      },
      topicUrl: 'learn/app-development',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Blockchain',
        es: 'Blockchain',
      },
      topicUrl: 'learn/blockchain',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'C Programming',
        es: 'Programación en C',
      },
      topicUrl: 'learn/c-programming',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Computer Programming',
        es: 'Programación de computadoras',
      },
      topicUrl: 'learn/computer-programming',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Cybersecurity',
        es: 'Seguridad cibernética',
      },
      topicUrl: 'learn/cybersecurity',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Information Technology',
        es: 'Tecnologías de la información',
      },
      topicUrl: 'learn/information-technology',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Java',
        es: 'Java',
      },
      topicUrl: 'learn/java',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Linux',
        es: 'Linux',
      },
      topicUrl: 'learn/linux',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Python',
        es: 'Python',
      },
      topicUrl: 'learn/python',
      inProspectus: true,
    },
  },
  {
    relatedTopic: {
      topicString: {
        en: 'Web Development',
        es: 'Desarrollo web',
      },
      topicUrl: 'learn/web-development',
      inProspectus: true,
    },
  },
];

const getTopic = label => (
  i18nTopicList.find(({ relatedTopic: topic }) => topic.topicString.en === label));

const getI18nTopicLabel = (label, locale = 'en') => {
  const topicObject = getTopic(label);

  // If the topic isn't in the topic list return the passed in string
  if (!topicObject) {
    return label;
  }

  const { relatedTopic } = topicObject;

  return locale === 'es' ? relatedTopic.topicString.es : relatedTopic.topicString.en;
};

const getI18nTopic = (label, locale = 'en') => {
  const topicObject = getTopic(label);
  const { relatedTopic } = topicObject;

  return {
    relatedTopic: {
      topicString: locale === 'es' ? relatedTopic.topicString.es : relatedTopic.topicString.en,
      topicUrl: relatedTopic.topicUrl,
      inProspectus: relatedTopic.inProspectus,
    },
  };
};

// TODO: Don't hardcode these
const getRelatedTopics = (subjectSlug, locale = 'en') => {
  if (subjectSlug === 'data-science') {
    return [
      'Data Analysis',
      'Excel',
      'Machine Learning',
      'R Programming',
      'SQL',
    ].map(label => getI18nTopic(label, locale));
  }

  return [
    'App Development',
    'Blockchain',
    'C Programming',
    'Computer Programming',
    'Cybersecurity',
    'Information Technology',
    'Java',
    'Linux',
    'Python',
    'Web Development',
  ].map(label => getI18nTopic(label, locale));
};

// The subjects to support for the initial topic routing
const subjectsForTopics = ['data-science', 'computer-science'];

const subjectToTopicSlugs = {
  architecture: {
    en: 'architecture', es: 'arquitectura',
  },
  'art-culture': {
    en: 'art', es: 'arte',
  },
  'biology-life-sciences': {
    en: 'biology', es: 'biologia',
  },
  'business-management': {
    en: 'business-administration', es: 'administracion-de-empresas',
  },
  chemistry: {
    en: 'chemistry', es: 'quimica',
  },
  communication: {
    en: 'business-communications', es: 'comunicacion',
  },
  'computer-science': {
    en: 'computer-programming', es: 'programacion-informatica',
  },
  'data-science': {
    en: 'data-analysis', es: 'analisis-de-datos',
  },
  design: {
    en: 'design', es: 'diseno',
  },
  'economics-finance': {
    en: 'economics', es: 'economia',
  },
  'education-teacher-training': {
    en: 'education', es: 'educacion',
  },
  electronics: {
    en: 'electronics', es: 'ingenieria-electrica',
  },
  'energy-earth-sciences': {
    en: 'energy', es: 'energia',
  },
  engineering: {
    en: 'engineering', es: 'ingenieria',
  },
  'environmental-studies': {
    en: 'environmental-science', es: 'medio-ambiente',
  },
  ethics: {
    en: 'ethics', es: 'desafios-eticos',
  },
  'food-nutrition': {
    en: 'nutrition', es: 'nutricion',
  },
  'health-safety': {
    en: 'healthcare', es: 'cuidado-de-la-salud',
  },
  history: {
    en: 'history', es: 'historia',
  },
  humanities: {
    en: 'humanities', es: 'humanidades',
  },
  language: {
    en: 'language', es: 'idiomas',
  },
  law: {
    en: 'law', es: 'leyes',
  },
  literature: {
    en: 'literature', es: 'literatura',
  },
  math: {
    en: 'math', es: 'matematicas',
  },
  medicine: {
    en: 'medicine', es: 'medicina',
  },
  music: {
    en: 'music-arts', es: 'musica',
  },
  philanthropy: {
    en: 'humanities', es: 'humanidades',
  },
  'philosophy-ethics': {
    en: 'ethics', es: 'filosofia',
  },
  physics: {
    en: 'physics', es: 'fisica',
  },
  science: {
    en: 'science', es: 'ciencias-naturales',
  },
  'social-sciences': {
    en: 'social-science', es: 'ciencias-sociales',
  },
  'data-analysis-statistics': {
    en: 'data-analysis-statistic',
    es: 'analisis-de-datos',
  },
};

const getTopicUrl = (locale, subjectSlug) => {
  const topicSlug = subjectToTopicSlugs[subjectSlug][locale] || '';
  const topicUrl = locale === 'es' ? `/es/aprende/${topicSlug}` : `/learn/${topicSlug}`;
  return topicUrl;
};

module.exports = {
  getI18nTopicLabel,
  getRelatedTopics,
  subjectsForTopics,
  getTopicUrl,
  subjectToTopicSlugs,
};
